<template>
  <div class="test-content">
    <ul>
        <ToDoLi v-for = "(pep,index) in arr" :content="pep" :key="index" v-on:listenToChildEvent="showMsg"></ToDoLi>
    </ul>
  </div>
</template>
<script>
import ToDoLi from '../components/ToDoLi';
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
import { mapState } from 'vuex'

export default {
  props: {
    id: Number
  },
  name: 'ZooTopia',
  components:{
    'ToDoLi':ToDoLi
  },
  data () {
    return {
        arr:[
            {'num':1,'order':'1/28','title':'我对自己有清晰的了解（如兴趣、性格、能力、价值观），并且短时间内不会改变。','A':'是','B':'否','show':true},
            {'num':2,'order':'2/28','title':'基于自己的个性特点，我知道自己适合做哪种类型的工作。','A':'是','B':'否','show':false},
            {'num':3,'order':'3/28','title':'我清楚自己的职业偏好是什么（如，我想要怎样的人际关系？我喜欢什么样的工作环境？我愿意在工作中运用什么能力？）。','A':'是','B':'否','show':false},
            {'num':4,'order':'4/28','title':'我知道自己的长处和短处，以及它们对我的人际、学习、未来工作的影响。','A':'是','B':'否','show':false},
            {'num':5,'order':'5/28','title':'业余时间里我有自己喜欢做的事，它（们）让我觉得放松/充实（而不是有虚度光阴的负罪感）。','A':'是','B':'否','show':false},
            {'num':6,'order':'6/28','title':'我参加各种活动来发现或培养自己的兴趣爱好。','A':'是','B':'否','show':false},
            {'num':7,'order':'7/28','title':'面对压力，我有自己的健康的解压方式，且行之有效。','A':'是','B':'否','show':false},
            {'num':8,'order':'8/28','title':'我能控制住自己的剁手，消费欲望与自己的经济条件成正比（而不是每月入不敷出，靠借贷度日）。','A':'是','B':'否','show':false},
            {'num':9,'order':'9/28','title':'我能列举出与专业相关的50个职业。','A':'是','B':'否','show':false},
            {'num':10,'order':'10/28','title':'我能列举出与自己感兴趣的50个职业。','A':'是','B':'否','show':false},
            {'num':11,'order':'11/28','title':'我对自己感兴趣的行业和职业的情况如数家珍（如发展趋势，市场需求，对从业者的能力要求）。','A':'是','B':'否','show':false},
            {'num':12,'order':'12/28','title':'对于考研、就业等不同的毕业去向，我能清楚的说出它们各自的优势和劣势。','A':'是','B':'否','show':false},
            {'num':13,'order':'13/28','title':'我和同学、学长、老师等讨论升学或未来的职业。','A':'是','B':'否','show':false},
            {'num':14,'order':'14/28','title':'我与自己目标职业领域的专业/业内人士去交流以获取职业信息。','A':'是','B':'否','show':false},
            {'num':15,'order':'15/28','title':'我通过兼职、实习等各种方式探索自己可能的发展方向/发展机会。','A':'是','B':'否','show':false},
            {'num':16,'order':'16/28','title':'我有意识的建立人际网络（如和老师、学长、兼职/实习中结识的人保持良好的关系），并运用这些关系来拓展可能的就业机会。','A':'是','B':'否','show':false},
            {'num':17,'order':'17/28','title':'我通过网络、招聘会、就业指导中心等多个渠道寻找可能的职业/工作机会。','A':'是','B':'否','show':false},
            {'num':18,'order':'18/28','title':'我能够清晰的说出自己的职业目标。','A':'是','B':'否','show':false},
            {'num':19,'order':'19/28','title':'经过大量的职业分析和自我分析，我已经确定了将来要从事的职业。','A':'是','B':'否','show':false},
            {'num':20,'order':'20/28','title':'基于各种权衡比较，我已经决定了毕业后的出路（如工作、考研还是出国）。','A':'是','B':'否','show':false},
            {'num':21,'order':'21/28','title':'我对以上自己所做的决策（目前的决策状态）感到满意。','A':'是','B':'否','show':false},
            {'num':22,'order':'22/28','title':'我相信自己已（能）做出适合自己的职业选择，并不担心是对还是错。','A':'是','B':'否','show':false},
            {'num':23,'order':'23/28','title':'我清楚自己想要的理想生活是怎样的，并为此制定了清晰的目标和可操作的行动计划。','A':'是','B':'否','show':false},
            {'num':24,'order':'24/28','title':'我知道自己现在需要做哪些专业积累和能力训练，才能提高在未来工作岗位上的胜任力。','A':'是','B':'否','show':false},
            {'num':25,'order':'25/28','title':'对于未来的出路我已有目标，我的选课、专业学习、参加的培训等都在朝着这个目标努力。','A':'是','B':'否','show':false},
            {'num':26,'order':'26/28','title':'我积极争取各种与未来想从事职业相关的兼职、实习机会，以提高自己的竞争力。','A':'是','B':'否','show':false},
            {'num':27,'order':'27/28','title':'我周期性的反思总结自己的行动效果，评估现实与理想之间的差距。','A':'是','B':'否','show':false},
            {'num':28,'order':'28/28','title':'我根据兴趣特长或未来的发展持续打磨自己的一项技能。','A':'是','B':'否','show':false},
          ],
          data:'',
          submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-大学生ToDoList');
  },
  methods:{
      showMsg(cur,res){
        this.arr.map((item)=>{
          if(item.show){
            item.show=false;
          }
          if(item.num==(cur+1)){
              item.show=true;
              return true;
            }else if((cur+1)>28){
                console.log("循环结束");
            }
        })
        this.data+=cur+"$"+res;
        if((cur+1)<=28){
          this.data+="}";
        }else{
          if(this.submitNum==0){
            this.submitNum=1
            const options = {
              method: 'POST',
              headers: { 'content-type': 'application/x-www-form-urlencoded'},
              data:qs.stringify({
                submitdata: this.data,
                openId: this.shengyaUser.openid
              }),
              url:'/cob/saveCosTdlAnswer.do'
            };
            axios(options)
            .then((response)=>{
              if(response.data.result.success){
                let cosAnswer = response.data
                let shengyaUser = cosAnswer.data.user
                // 弹幕
                let num = cosAnswer.data.tdlAnswer.match(/\$0/g).length
                store.dispatch('finishPlay', {missionId:this.id,cosAnswer:'的to do list完成率为'+parseInt((num/28)*100)+"%"})
                this.$bus.$emit('play-finish', shengyaUser)
              }
            })
            .catch((error)=>{
              console.log(error);
            });
          }
        }
    }
  }
}
</script>
<style>
</style>
